import {
  dispatchPreferenceChanged,
  readStoredEnum,
  writeStoredEnum
} from './preferenceStorage';

export type ViewerOpenMode = 'inAppPopup' | 'inAppTab' | 'browserTab';

export const VIEWER_OPEN_MODE_KEY = 'jarvisViewerOpenMode';
export const VIEWER_OPEN_MODE_CHANGED = 'jarvis-viewer-open-mode-changed';
export const DEFAULT_VIEWER_OPEN_MODE: ViewerOpenMode = 'inAppPopup';

const MODES: readonly ViewerOpenMode[] = ['inAppPopup', 'inAppTab', 'browserTab'];

export function getViewerOpenMode(): ViewerOpenMode {
  return readStoredEnum(VIEWER_OPEN_MODE_KEY, MODES, DEFAULT_VIEWER_OPEN_MODE);
}

export function setViewerOpenMode(mode: ViewerOpenMode): void {
  const next = MODES.includes(mode) ? mode : DEFAULT_VIEWER_OPEN_MODE;
  writeStoredEnum(VIEWER_OPEN_MODE_KEY, next);
  dispatchPreferenceChanged(VIEWER_OPEN_MODE_CHANGED, next);
}
